
export class UrlBuilder {
    constructor(private url: string) {
    }

    public addChainId(chainId: number): UrlBuilder {
        this.url = this.url.replace('{chainId}', chainId.toString());

        return this;
    }

    public addTransactionId(transactionId: string): UrlBuilder {
        this.url = this.url.replace('{transactionId}', transactionId);

        return this;
    }

    public addConversationId(conversationId: string): UrlBuilder {
        this.url = this.url.replace('{conversationId}', conversationId);

        return this;
    }

    public addTurnId(turnId: string): UrlBuilder {
        this.url = this.url.replace('{turnId}', turnId);

        return this;
    }

    public addQueryParameter(key: string, value: string): UrlBuilder {
        const separator = this.url.includes('?') ? '&' : '?';
        this.url = `${this.url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

        return this;
    }

    public toUrl(): string {
        return this.url;
    }
}
